export default __webpack_public_path__ + "static/media/icon_teacher.0c419a9c.svg";